export default "__VITE_ASSET__Bk6BsR7O__"